/**
 * @contract
 *   Назначение: Клиентский компонент формы поиска ЧОП по ИНН
 *   Используется: page.tsx (tools/proverka-chop)
 *   Аудитория: Посетители, проверяющие ЧОП по ИНН
 */

'use client';

import { useState } from 'react';
import { useRouter } from 'next/navigation';
import { Search } from 'lucide-react';

export function InnSearchForm() {
  const [inn, setInn] = useState('');
  const [error, setError] = useState('');
  const router = useRouter();

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const trimmed = inn.trim().replace(/\D/g, '');

    if (!/^\d{10,12}$/.test(trimmed)) {
      setError('Введите корректный ИНН (10 или 12 цифр)');
      return;
    }

    setError('');

    // Яндекс.Метрика — цель поиска по ИНН
    try {
      (window as any).ym?.(107253138, 'reachGoal', 'proverka_inn_search');
    } catch {
      // Метрика не загружена — не критично
    }

    router.push(`/chop/${trimmed}`);
  };

  return (
    <form onSubmit={handleSubmit} className="w-full">
      <div className="flex flex-col sm:flex-row gap-3">
        <div className="flex-1 relative">
          <input
            type="text"
            inputMode="numeric"
            value={inn}
            onChange={(e) => {
              setInn(e.target.value);
              if (error) setError('');
            }}
            placeholder="Введите ИНН (10 или 12 цифр)"
            maxLength={12}
            className="w-full h-14 px-5 bg-black border border-white/20 text-white placeholder:text-white/25 font-mono text-lg tracking-wider uppercase focus:outline-none focus:border-white/50 focus:ring-0 transition-colors"
            autoComplete="off"
            aria-label="ИНН частного охранного предприятия"
          />
        </div>
        <button
          type="submit"
          className="h-14 px-8 bg-white text-black hover:bg-white/90 uppercase tracking-widest text-xs font-bold transition-all flex items-center justify-center gap-3 shrink-0"
        >
          <Search className="h-4 w-4" />
          Проверить
        </button>
      </div>
      {error && (
        <p className="text-red-400 text-xs mt-3 font-sans flex items-center gap-2">
          <span className="w-1 h-1 bg-red-400 shrink-0" />
          {error}
        </p>
      )}
    </form>
  );
}
